<template>
  <meta name="viewport" :content="content">
</template>

<script>
import store from '../store'

export default {
  computed: {
    content () {
      const viewport = store.state.viewport
      const list = []

      for (var field in viewport) {
        list.push(`${field}=${viewport[field]}`)
      }

      const content = list.join(', ')
      return content
    }
  }
}
</script>
